import { useGetPackageCover } from 'app/hooks/data/packages/usePackages';
import type {
  IHotelWithDetails,
  IMergePackageItem,
} from 'app/typings/migrationTool/HotelWithDetails';

import type { MergeSelection } from '../../HotelMigration';
import { MigrationLayout } from '../MigrationLayout';

type PackagesProps = {
  hotels?: IHotelWithDetails[];
  parentHotelId: number;
  childHotelId?: number;
  selections: Record<number, MergeSelection>;
  setSelections: (newSelections: Record<number, MergeSelection>) => void;
};

export const Packages = ({
  hotels,
  parentHotelId,
  childHotelId,
  selections,
  setSelections,
}: PackagesProps) => {
  const parentHotel = hotels?.find((h) => h.hotel.id === parentHotelId);
  const childHotel = hotels?.find((h) => h.hotel.id === childHotelId);

  const { data: packageCover } = useGetPackageCover(
    childHotel?.packages[0]?.id ?? null
  );

  if (!parentHotel || !childHotel || !packageCover) {
    return null;
  }

  const newPackagesList = childHotel?.packages.map((pkg) => ({
    ...pkg,
    coverPicture: {
      ...packageCover?.horizontalCoverPicture,
      path: packageCover?.horizontalCoverPicture.pictureId,
    },
  }));

  return (
    <MigrationLayout<IMergePackageItem>
      title="Merge packages from your child hotel with your parent hotel"
      description="You can decide to merge an existing package, not migrate one, or create a new package in the parent hotel."
      childHotel={childHotel.hotel.name}
      hotel={parentHotel}
      actionList={[]}
      items={newPackagesList}
      getItemId={(pkg) => pkg.id}
      entityLabel="Package"
      selections={selections}
      setSelections={setSelections}
    />
  );
};
